import React from 'react';
import { object } from 'prop-types';
import ContactForm from '../../components/Business/ContactForm';
import BusinessLayout2024 from '../../components/Layout/BusinessLayout2024';
import { PAGE_URLS } from '../../constants';

// this is a clone of the contact page, except to be used to access a gated kilo product sheet pdf
const BusinessKiloProductSheetPage = (props) => {
  const { location } = props;

  return (
    <BusinessLayout2024
      location={location}
      customTitle="Download kilo product sheet"
      // eslint-disable-next-line max-len
      customDescription="To learn more about our business solutions and to find the right product for you, feel free to reach out to our team at business@piaggiofastforward.com"
      customImage="//piaggiofastforward.imgix.net/GENERAL_PAGES/kilo-in-warehouse.png?w=1200&fm=jpg"
      customImageTwitter="//piaggiofastforward.imgix.net/GENERAL_PAGES/kilo-in-warehouse.png?w=1600&fm=jpg"
      metaTitle="Download kilo product sheet"
      canonicalURL={PAGE_URLS.CANONICAL_URLS?.BUSINESS_KILO_PRODUCT_SHEET}
      customImageAltText="kilo robot in a warehouse"
    >
      <div
        className="h-[300px] bg-gradient-to-b from-[#032137] from-0% via-[#023E58] via-45% to-[#032137] to-100% flex
          items-end"
      >
        <div className="px-14 sm:px-20">
          <h2 className="text-[32px] tracking-[0.45px] font-brownNormalBold mb-10 pb-7 text-cerulean-400">
            Let’s discuss how our solution can
            <br className="hidden md:block" /> help transform your business.
          </h2>
        </div>
      </div>
      <div className="bg-[#032137]">
        <div className="lg:max-w-[65%] px-14 sm:px-20">
          <ContactForm gated />
        </div>
      </div>
    </BusinessLayout2024>
  );
};

BusinessKiloProductSheetPage.propTypes = {
  location: object,
};

export default BusinessKiloProductSheetPage;
